import { render, staticRenderFns } from "./BtnHelp.vue?vue&type=template&id=1cfd0282&scoped=true"
import script from "./BtnHelp.vue?vue&type=script&lang=js"
export * from "./BtnHelp.vue?vue&type=script&lang=js"
import style0 from "./BtnHelp.vue?vue&type=style&index=0&id=1cfd0282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd0282",
  null
  
)

export default component.exports